<template>
  <b-card>
    <div class="row mb-3 mt-3 align-items-center">
      <div class="col-md-8">
        <v-select
          v-model="edu_course"
          :options="edu_courses"
          class="w-100"
          label="for_v_select"
          :item-text="getFieldText"
          :reduce="(type) => type.id"
          @input="update()"
        />
      </div>
      <div class="col-md-4">
        <b-button
          variant="outline-info"
          :to="{
            name: 'ActivityUserAnswerReport',
            params: { id: edu_course},
          }"
        >
          {{ $t("activities.report") }}
        </b-button>
      </div>
    </div>
  </b-card>
</template>
   
   <script>
import ActivitiesController from "@/Controllers/ActivitiesController";
import vSelect from "vue-select";
import EduCoursesController from "@/Controllers/EduCoursesController";
import Auth from "@/Apis/Auth";

export default {
  props: ["items", "editItem"],
  components: {
    vSelect,
  },
  data() {
    return {
      data: [],
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      user: {},
      eduPrograms: [],
      activityFields: [],
      edu_courses: [],
      edu_course: 0,
    };
  },
  async created() {
    if (Auth.USER.account_type == "teacher") {
      const res = await new ActivitiesController().teacherCourses({
        edu_program: localStorage.getItem("eduProgram"),
      });
      if (res) {
        res.map((e) => {
          this.edu_courses.push(e.course);
        });
        this.edu_courses.forEach((el) => {
          el.for_v_select = el.code + " " + el.name;
        });
      }
    } else {
      this.edu_courses = await new EduCoursesController().GetAll();
      this.edu_courses.forEach((el) => {
        el.for_v_select = el.code + " " + el.name;
      });
    }
  },
  methods: {
    update() {
      this.dataProvider(this.params);
    },
    getFieldText(item) {
      return item.code + " " + item.name;
    },
  },
};
</script>
   
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
     